export default __webpack_public_path__ + "static/6-973c5d6cd2b7ae7d1527d5ab3fd2a3ce.webp";